import { render, staticRenderFns } from "./HomeBuySell.vue?vue&type=template&id=bcd89658&scoped=true&"
import script from "./HomeBuySell.vue?vue&type=script&lang=js&"
export * from "./HomeBuySell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd89658",
  null
  
)

export default component.exports